export default "__VITE_ASSET__CsdtBCg7__"